import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import { InputSwitch } from "primereact/inputswitch";
import TooltipConfigEditor from "components/dashboard/tooltip-config-editor/TooltipConfigEditor";
import TimeSpanInputs from "components/fragments/product-template-configurator/ProductTemplateAttributesConfiguration/type-fields/components/TimeSpanInputs";
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";
import React from "react";
import { T } from "services/lang/LanguageService";
import { Divider } from "primereact/divider";
import { DatasetStatusIndicatorProps } from "../DatasetStatusIndicatorTypes";

interface GeneralPropertiesEditorProps {
  currentConfig: DatasetStatusIndicatorProps;
  onConfigChange: (newConfig: DatasetStatusIndicatorProps) => void;
}

const GeneralPropertiesEditor = ({ currentConfig, onConfigChange }: GeneralPropertiesEditorProps) => {
  const handleDatasetChange = (value: string | null) => {
    onConfigChange({ ...currentConfig, identifier: value ?? "" });
  };

  const handleConfigChange = (e: InputNumberChangeEvent, id: string) => {
    onConfigChange({ ...currentConfig, [id]: e.value });
  };

  const handleMaxAgeChange = (value: number) => {
    onConfigChange({ ...currentConfig, maxAge: value ?? 0 });
  };

  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-row gap-2">
        <div className="flex flex-column gap-2 w-10">
          <label htmlFor="valueDataset">{T("word.dataset")}</label>
          <DatasetDropdown value={currentConfig.identifier ?? ""} onChange={handleDatasetChange} />
        </div>
        <div className="flex flex-column gap-2 w-2">
          <label htmlFor="useTooltip">{T("word.use-tooltip")}</label>
          <InputSwitch
            id="useTooltip"
            checked={currentConfig.useTooltip ?? false}
            onChange={e => onConfigChange({ ...currentConfig, useTooltip: e.value })}
          />
        </div>
      </div>
      <Divider className="m-0" />
      <div className="flex flex-wrap md:flex-nowrap gap-3 mb-3">
        <div className="gap-2 w-10 flex flex-column justify-content-center">
          <label>{`${T("word.datasets")} ${T("word.max")} ${T("word.age").toLowerCase()}`}</label>
          <div className="p-inputgroup">
            <TimeSpanInputs value={currentConfig.maxAge ?? 0} onChange={handleMaxAgeChange} />
          </div>
        </div>
        <div className="flex flex-column gap-2 w-2">
          <label htmlFor="updateFrequency">{T("load-conf.update-frequency")}</label>
          <InputNumber
            id="updateFrequency"
            value={currentConfig.updateFrequency}
            onChange={e => handleConfigChange(e, "updateFrequency")}
          />
        </div>
      </div>
      {currentConfig.useTooltip && (
        <>
          <Divider className="m-0" />
          <TooltipConfigEditor config={currentConfig} onChange={onConfigChange} />
        </>
      )}
    </div>
  );
};

export default GeneralPropertiesEditor;
